import React, { useState } from "react";
import CustomDropdown from "./dropdown";

const JobSelectionModal = ({
    currentJobs,
    setSelectedJob,
    onClose,
    isOpen,
    selectedJob,  
    handleSubmit
}) => {
    const [isLoading, setIsLoading] = useState(false);
    if (!isOpen) return null;

    const handleProceedClick = async () => {
        setIsLoading(true);
        try {
            await handleSubmit();
        } finally {
            setIsLoading(false);
        }
    };

    return (
        <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50 transition-opacity duration-300 ease-in-out anim-slideDown" onClick={(e) => e.stopPropagation()}>

            {/* Modal Container: Enlarged, better rounded corners, and a subtle shadow */}
            <div className="bg-white rounded-lg shadow-2xl w-1/2 h-auto mx-4 relative transform transition-all duration-300 ease-in-out scale-95">
                {/* Modal Body */}
                <div className="p-6 space-y-4">
                    <p className="text-sm text-gray-600">
                        Please select a job from the list below to proceed with your application.
                    </p>

                    {/* Custom Dropdown */}
                    <div className="relativeDiv">
                        <label htmlFor="job-select" className="block text-sm font-medium text-gray-700 mb-1">
                            Available Jobs
                        </label>
                        {/* Assuming CustomDropdown is already styled. If not, you can style it here. */}
                        <CustomDropdown
                            id="job-select"
                            options={currentJobs}
                            onChange={setSelectedJob}
                            value={selectedJob}
                            isJobList={true}
                        />
                    </div>
                </div>

                {/* Footer and Action Buttons */}
                <div className="flex items-center justify-end p-3 rounded-b-lg">
                    <button
                        type="button"
                        onClick={onClose}
                        className="px-3 py-1 rounded-full text-xs font-medium text-gray-700 bg-white border border-gray-300 hover:shadow-lg focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-400 transition-all"
                        disabled={isLoading}
                    >
                        Cancel
                    </button>
                    <button
                        type="button"
                        onClick={handleProceedClick}
                        className={`ml-3 px-3 py-1 rounded-full text-xs font-medium text-white profiler-bg transition-all hover:shadow-lg ${isLoading ? "opacity-60 cursor-not-allowed" : ""}`}
                        disabled={isLoading || !selectedJob}
                    >
                        {isLoading ? (
                            <span className="flex items-center">
                                <svg className="animate-spin h-4 w-4 text-white inline-block mr-2" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24">
                                    <circle className="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" strokeWidth="4"></circle>
                                    <path className="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8V0C5.373 0 0 5.373 0 12h4z"></path>
                                </svg>
                                Loading...
                            </span>
                        ) : (
                            <>Proceed</>
                        )}
                    </button>
                </div>

            </div>
        </div>
    );
};

export default JobSelectionModal;